import { MoneyMapRulePercentage } from '@fruitful/money-map';
import type {
    DeepPartial,
    MoneyMapRuleWithAccountDetails,
} from '@fruitful/types';
import { BodyMediumRegular, XStack, YStack } from 'smoothie';

import { DragHandle } from './DragHandle';
import { GoalRuleChips } from './GoalRuleChips';
import {
    DRAG_PINK,
    goalTileFocusRingStyle,
    GROUP_GOAL_ROW_MIN_HEIGHT,
} from './goalsWaterfallConstants';
import type { DragHandleProps } from './goalsWaterfallTypes';

interface GroupGoalRowProps {
    rule: DeepPartial<MoneyMapRuleWithAccountDetails>;
    isDragOverlay?: boolean;
    dragHandleProps?: DragHandleProps;
    isSelected?: boolean;
    onPress?: () => void;
    onPressPercentage?: () => void;
}

export const GroupGoalRow = ({
    rule,
    isDragOverlay = false,
    dragHandleProps,
    isSelected = false,
    onPress,
    onPressPercentage,
}: GroupGoalRowProps) => (
    <XStack
        backgroundColor="#FAFAFA"
        borderRadius={12}
        padding={12}
        minHeight={GROUP_GOAL_ROW_MIN_HEIGHT}
        gap={10}
        alignItems="center"
        cursor={
            isDragOverlay ? 'grabbing' : onPress != null ? 'pointer' : 'default'
        }
        {...(!isDragOverlay && {
            ...(isSelected
                ? {
                      style: goalTileFocusRingStyle(DRAG_PINK),
                  }
                : {}),
        })}
        onPress={!isDragOverlay ? onPress : undefined}
    >
        {!isDragOverlay && onPressPercentage != null ? (
            <XStack
                alignItems="center"
                cursor="pointer"
                onPress={(e) => {
                    const evt = e as unknown as {
                        stopPropagation?: () => void;
                    };
                    evt.stopPropagation?.();
                    onPressPercentage();
                }}
            >
                <MoneyMapRulePercentage percentage={rule.percentage ?? 0} />
            </XStack>
        ) : (
            <XStack alignItems="center" cursor="inherit">
                <MoneyMapRulePercentage percentage={rule.percentage ?? 0} />
            </XStack>
        )}
        <YStack flex={1} minWidth={0}>
            <BodyMediumRegular numberOfLines={1}>
                {rule.description}
            </BodyMediumRegular>
        </YStack>
        <GoalRuleChips rule={rule} />
        {dragHandleProps != null && (
            <DragHandle {...dragHandleProps} iconSize={16} />
        )}
    </XStack>
);
